import React from 'react';
import { Table } from 'antd';
const ORG_TYPE_LABELS = {
    '0': '普通部门',
    '1': '邮件列表',
    '2': '可IM组织',
    '99': '顶级节点',
    '2000': '群组',
    '2001': 'IM其他',
    '2002': '客户分组',
};
function renderBreakdown(breakdown, tableName) {
    if (!breakdown)
        return '—';
    const entries = Object.entries(breakdown).filter(([, v]) => v > 0);
    if (entries.length === 0)
        return '—';
    return (React.createElement("span", null, entries.map(([key, val], idx) => {
        var _a;
        const displayKey = tableName === 'org' ? (_a = ORG_TYPE_LABELS[key]) !== null && _a !== void 0 ? _a : key : key;
        return (React.createElement("span", { key: key },
            idx > 0 && React.createElement("span", { style: { color: '#ccc', margin: '0 4px' } }, "/"),
            React.createElement("span", { style: { color: '#666' } },
                displayKey,
                ":"),
            " ",
            React.createElement("span", { style: { fontWeight: 500 } }, val.toLocaleString())));
    })));
}
const columns = [
    {
        title: '表名',
        dataIndex: 'tableName',
        key: 'tableName',
        width: 160,
        render: (name) => React.createElement("code", null, name),
    },
    {
        title: '总记录数',
        dataIndex: 'total',
        key: 'total',
        width: 120,
        align: 'right',
        render: (v) => v.toLocaleString(),
    },
    {
        title: '分组明细',
        key: 'breakdown',
        render: (_, record) => renderBreakdown(record.breakdown, record.tableName),
    },
];
const DexieStatsSection = ({ dexieTables, loading }) => {
    return React.createElement(Table, { columns: columns, dataSource: dexieTables !== null && dexieTables !== void 0 ? dexieTables : [], rowKey: "tableName", pagination: false, size: "small", loading: loading });
};
export default DexieStatsSection;
